module.exports = __webpack_public_path__ + "img/mati.f4769378.png";